import { NavigationPath } from "../../../config/routing/NavigationPath";

export const clientsPaths = [
   {id: NavigationPath.UNVERIFIED_CLIENTS, name: "nav.unverifiedClients"},
   {id: NavigationPath.ACTIVE_CLIENTS, name: "nav.activeClients"},
   {id: NavigationPath.INACTIVE_CLIENTS, name: "nav.inactiveClients"},
   {id: NavigationPath.RECEPTION_PLACES, name: "nav.receptionPlaces"},
];

export const validatorsPaths = [
   {id: NavigationPath.CONTAINERS_VALIDATORS, name: "nav.containersValidators"},
   {id: NavigationPath.RECEPTION_PLACES_VALIDATORS, name: "nav.receptionPlacesValidators"},
   {id: NavigationPath.ORDERS_VALIDATORS, name: "nav.ordersValidators"},
]

export const priceListPaths = [
   {id: NavigationPath.GENERAL_PRICE_LIST, name: "nav.generalPricelist"},
   {id: NavigationPath.DETAILED_PRICE_LIST, name: "nav.detailedPricelist"},
]

export const ordersPaths = [
   {id: NavigationPath.NEW_ORDERS, name: "nav.newOrders"},
   {id: NavigationPath.ACCEPTED_ORDERS, name: "nav.acceptedOrders"},
   {id: NavigationPath.IN_PROGRESS_ORDERS, name: "nav.inProgressOrders"},
   {id: NavigationPath.COMPLETED_ORDERS, name: "nav.completedOrders"},
   {id: NavigationPath.INVOICED_ORDERS, name: "nav.invoicedOrders"},
   {id: NavigationPath.CANCELED_ORDERS, name: "nav.canceledOrders"},
   {id: NavigationPath.ALL_ORDERS, name: "nav.allOrders"},
]

export const configPaths = [
   {id: NavigationPath.ORDER_TYPES, name: "nav.orderTypes"},
   {id: NavigationPath.VEHICLES, name: "nav.vehicles"},
   {id: NavigationPath.DRIVERS, name: "nav.drivers"},
]